import { View } from "extensions/marionette";

import { _ } from "extensions/underscore";
import humanize from "lodash-es/startCase";

import { Bloodhound, Sources } from "common/components/typeahead";
import { references } from "common/helpers/references";

import { View as TokenfieldView, Model as TokenfieldModel } from "common/components/tokenfield";

import searchCredentialsTemplate from "./searchUsers.jst";

export const SearchUsersInput = View.extend({
    className: "searchUsers",
    template: searchCredentialsTemplate,
    
    regions: {
        search: ".search-box-cont"
    },
    
    getMerchantsModel() {
        const allTopLevelMerchants = references.getAliasGroupByType("merchant").map((merchant) => ({
            value: merchant.id,
            label: merchant.display_name,
            group: "merchant_ref"
        }));
        
        const bloodhoundInstance = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace(["label", "value"]),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            local: allTopLevelMerchants
        });
        
        const originalSearchFn = bloodhoundInstance.search;
        
        // Wrap search with our function to filter already selected group of results
        bloodhoundInstance.search = (q, sync) => {
            originalSearchFn.call(bloodhoundInstance, q, (results) => {
                const currentGroups = this.userSearch.getTokensGroups();
                sync(results.filter((r) => !currentGroups.includes(r.group)));
            });
        };
        
        return {
            display: ["label"],
            source: bloodhoundInstance,
            templates_suggestion: (data) => `<div><strong>${data.label}</strong> <em>under Merchants</em></div>`
        };
    },
    
    initTypeahead() {
        const sourcesCollection = new Sources([
            this.getMerchantsModel()
        ]);
        
        let initialTokens;
        if (this.getOption("merchant_ref")) {
            initialTokens = [{
                value: this.getOption("merchant_ref"),
                label: references.toAlias(this.getOption("merchant_ref"), "merchant"),
                group: "merchant_ref"
            }];
        }
        
        this.userSearch = new TokenfieldView({
            collection: sourcesCollection,
            model: new TokenfieldModel({
                autofocus: true,
                minWidth: 440,
                limit: 5,
                createTokensOnBlur: false,
                tokens: initialTokens,
                placeholder: "Filter by merchant or username"
            }),
            
            onTokenBeforeCreate(event) {
                // Populate group for fields that we took not from the typeahead sources
                if (!event.attrs.group) {
                    event.attrs.group = "name";
                }
                
                // Check if we already have any token from the same group inside the input
                const existingTokens = this.getTokens();
                // eslint-disable-next-line unicorn/prefer-array-some
                const hasSameGroupToken = _.any(existingTokens, (t) => !!_.find(existingTokens, (et) => et.group === event.attrs.group));
                if (hasSameGroupToken) {
                    event.preventDefault();
                }
            },
            
            onTokenCreate(event) {
                let addClass;
                let addTitle;
                
                if (event.attrs.group) {
                    addClass = `token-${event.attrs.group}`;
                    addTitle = humanize(event.attrs.group);
                }
                
                if (addClass) {
                    event.relatedTarget.classList.add(addClass);
                }
                
                if (addTitle) {
                    event.relatedTarget.setAttribute("aria-label", addTitle);
                    event.relatedTarget.classList.add("tooltipped");
                    event.relatedTarget.classList.add("tooltipped-n");
                }
            }
        });
    
        this.listenTo(this.userSearch, "token:create token:delete", () => {
            this.triggerMethod("tokens:update", this.userSearch.getTokens());
        });
        
        this.listenTo(this.userSearch, "render", () => {
            // Lock the tokenfield if has initial tokens
            if (initialTokens) {
                setTimeout(() => {
                    this.userSearch.ui.input.tokenfield("disable");
                }, 0);
            }
        });
        
        this.showChildView("search", this.userSearch);
    },
    
    onRender() {
        this.initTypeahead();
    }
});
